import { BannerId } from '../../../typings/banners';
import { InternalResourceId } from '../../../typings/internalBanners';

export const SHOW_INTERNAL_BANNER_IMAGE_LINK_INPUT = 'SHOW_INTERNAL_BANNER_IMAGE_LINK_INPUT';
export type SHOW_INTERNAL_BANNER_IMAGE_LINK_INPUT = typeof SHOW_INTERNAL_BANNER_IMAGE_LINK_INPUT;

export interface ShowInternalBannerImageLinkInput {
    type: SHOW_INTERNAL_BANNER_IMAGE_LINK_INPUT;
    bannerId: BannerId;
    resourceId: InternalResourceId;
}

export function showInternalBannerImageLinkInputAction(
    bannerId: BannerId,
    resourceId: InternalResourceId
): ShowInternalBannerImageLinkInput {
    return {
        type: SHOW_INTERNAL_BANNER_IMAGE_LINK_INPUT,
        bannerId,
        resourceId
    };
}
